"use strict";

var _defineProperty = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Analyzer = exports.isArangoAnalyzer = void 0;

var error_1 = require("./error");

var codes_1 = require("./lib/codes");
/**
 * Indicates whether the given value represents an {@link Analyzer}.
 *
 * @param analyzer - A value that might be an Analyzer.
 */


function isArangoAnalyzer(analyzer) {
  return Boolean(analyzer && analyzer.isArangoAnalyzer);
}

exports.isArangoAnalyzer = isArangoAnalyzer;
/**
 * Represents an Analyzer in a {@link Database}.
 */

var Analyzer = /*#__PURE__*/function () {
  /**
   * @internal
   * @hidden
   */
  function Analyzer(db, name) {
    _classCallCheck(this, Analyzer);

    this._db = db;
    this._name = name;
  }
  /**
   * @internal
   *
   * Indicates that this object represents an ArangoDB Analyzer.
   */


  _createClass(Analyzer, [{
    key: "isArangoAnalyzer",
    get: function get() {
      return true;
    }
    /**
     * Name of this Analyzer.
     *
     * See also {@link Database.analyzer}.
     */

  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
    /**
     * Checks whether the Analyzer exists.
     *
     * @example
     * ```js
     * const db = new Database();
     * const analyzer = db.analyzer("some-analyzer");
     * const result = await analyzer.exists();
     * // result indicates whether the Analyzer exists
     * ```
     */

  }, {
    key: "exists",
    value: function () {
      var _exists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.get();

              case 3:
                return _context.abrupt("return", true);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (!(error_1.isArangoError(_context.t0) && _context.t0.errorNum === codes_1.ANALYZER_NOT_FOUND)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", false);

              case 10:
                throw _context.t0;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function exists() {
        return _exists.apply(this, arguments);
      }

      return exists;
    }()
    /**
     * Retrieves the Analyzer definition for the Analyzer.
     *
     * @example
     * ```js
     * const db = new Database();
     * const analyzer = db.analyzer("some-analyzer");
     * const definition = await analyzer.get();
     * // definition contains the Analyzer definition
     * ```
     */

  }, {
    key: "get",
    value: function get() {
      return this._db.request({
        path: "/_api/analyzer/".concat(this.name)
      }, function (res) {
        return res.body;
      });
    }
    /**
     * Creates a new Analyzer with the given `options` and the instance's name.
     *
     * See also {@link Database.createAnalyzer}.
     *
     * @param options - Options for creating the Analyzer.
     *
     * @example
     * ```js
     * const db = new Database();
     * const analyzer = db.analyzer("potatoes");
     * await analyzer.create({ type: "identity" });
     * // the identity Analyzer "potatoes" now exists
     * ```
     */

  }, {
    key: "create",
    value: function create(options) {
      return this._db.request({
        method: "POST",
        path: "/_api/analyzer",
        body: _objectSpread({
          name: this.name
        }, options)
      }, function (res) {
        return res.body;
      });
    }
    /**
     * Deletes the Analyzer from the database.
     *
     * @param force - Whether the Analyzer should still be deleted even if it
     * is currently in use.
     *
     * @example
     * ```js
     * const db = new Database();
     * const analyzer = db.analyzer("some-analyzer");
     * await analyzer.drop();
     * // the Analyzer "some-analyzer" no longer exists
     * ```
     */

  }, {
    key: "drop",
    value: function drop() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._db.request({
        method: "DELETE",
        path: "/_api/analyzer/".concat(this.name),
        qs: {
          force: force
        }
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return Analyzer;
}();

exports.Analyzer = Analyzer;